import { render, staticRenderFns } from "./FavoritenReiter.vue?vue&type=template&id=2490bfc5"
import script from "./FavoritenReiter.vue?vue&type=script&lang=js"
export * from "./FavoritenReiter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports